import { Either } from 'purify-ts';
import { SessionRepositoryFailure } from './failure';
import { SsoRedirectQuery, SsoStart } from './types';

export abstract class ISessionRepository {
  public abstract signInWithSSO(): Promise<Either<SessionRepositoryFailure, SsoStart>>;

  public abstract exchangeSSOToken(
    queryObject: SsoRedirectQuery
  ): Promise<Either<SessionRepositoryFailure, void>>;

  public abstract refreshToken(): Promise<Either<SessionRepositoryFailure, string>>;

  public abstract signOut(): Promise<Either<SessionRepositoryFailure, { url: string }>>;

  public abstract fakeSignIn(): Promise<Either<SessionRepositoryFailure, void>>;
}
